import React, { cloneElement } from 'react';
import { string, bool, func, node } from 'prop-types';
import { Link } from 'react-router';
import cx from 'classnames';

import styles from './icon-button.scss';

function ButtonLayout({ children, label }) {
  // const Icon = iconComponent; // needs to be pascal cased for jsx
  return (
    <span className={styles.layout}>
      <span className={styles.iconContainer}>
        {cloneElement(children, { className: styles.icon })}
      </span>
      {label &&
        <span className={styles.label}>
          <span className={styles.labelText}>
            {label}
          </span>
        </span>}
    </span>
  );
}

ButtonLayout.propTypes = {
  children: node.isRequired,
  label: string,
};

export default function IconButton({
  isSecondary,
  iconRight,
  children,
  asLink,
  onClick,
  linkTo,
  label,
  hasContextBlue,
  withShadow,
  withShadowHover,
  disabled,
}) {
  const topLevelClassNames = cx(styles.main, {
    [styles.isPrimary]: !isSecondary,
    [styles.isSecondary]: isSecondary,
    [styles.iconRight]: iconRight,
    [styles.hasContextBlue]: hasContextBlue,
    [styles.withShadow]: withShadow,
    [styles.withShadowHover]: withShadowHover,
    [styles.asLink]: asLink,
  });
  /* render the button as a link */
  if (asLink) {
    return (
      <Link to={linkTo} className={topLevelClassNames} disabled={disabled}>
        <ButtonLayout
          label={label}
          className={cx(styles.layout, { [styles.hasLabel]: Boolean(label) })}
        >
          {children}
        </ButtonLayout>
      </Link>
    );
  }

  /* render the button as a button */
  return (
    <button onClick={onClick} className={topLevelClassNames} disabled={disabled}>
      <ButtonLayout
        label={label}
        className={cx(styles.layout, { [styles.hasLabel]: Boolean(label) })}
      >
        {children}
      </ButtonLayout>
    </button>
  );
}

IconButton.propTypes = {
  children: node,
  // requiredness gives lots of errors?
  // children: node.isRequired,
  label: string,
  asLink: bool,
  onClick: func,
  linkTo: string,
  isSecondary: bool,
  iconRight: bool,
  hasContextBlue: bool,
  withShadow: bool,
  withShadowHover: bool,
  disabled: bool,
};



// WEBPACK FOOTER //
// ./src/components/IconButton/index.js